const baseUrl = 'http://szhjerp.com/erp-web/';//外网地址，映射10.1.130.88
// const baseUrl = 'http://10.1.20.105:8080/erp-web/'; //本地开发
// const baseUrl = 'http://210.21.199.18:66/';//外网地址，映射10.1.130.88
// const baseUrl = 'http://10.1.20.75/';
export default{
    baseUrl
}



// WEBPACK FOOTER //
// ./src/common/js/global.js